export default Object.freeze({
  HELP: 'help',
  OTHER: 'other',
})
